import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { LinkTreeBranchComponent } from '../branch/branch.component';
import { LinkTreeLeafComponent } from '../leaf/leaf.component';
import { NavItem } from '../../models';

@Component({
  selector: 'ul[link-tree]',
  templateUrl: './tree.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    forwardRef(() => LinkTreeLeafComponent),
    forwardRef(() => LinkTreeBranchComponent)
  ],
})
export class LinkTreeComponent {
  readonly items = input.required<NavItem[]>();

  readonly depth = input(0);
}